import React, { useState, useEffect } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, MsalProvider  } from "@azure/msal-react";
import { loginRequest, msalConfig } from "../authConfig.js";

import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import AlertBox from './AlertBox'
import frm from './formAux.js'
import $ from 'jquery';


const AzureButton = () => {    
    const { instance, accounts } = useMsal();

    // msalConfig.auth.redirectUri = msalConfig.auth.redirectUri.replace(/\?.*/,'')
    // alert( JSON.stringify(msalConfig.auth.redirectUri) )
    function azureLogin(){
        console.log( 'lgn', loginRequest)
        instance.loginRedirect(loginRequest).catch(e => {
            console.log('result', e);
        });
    }

    function azureLogout(){
        window.endSession();
        localStorage.clear();
        document.location = window.servicePath + 'azure/signout';
        // console.log( 'lgn', loginRequest)
        // instance.logoutRedirect(loginRequest).catch(e => {
        //     console.log('result', e);
        // });
    }

    window.azureLogin = azureLogin;
    window.azureLogout = azureLogout;
    // console.log( 'ACCOUNTS', accounts )

    return (
        <>
            {/* <button id="azurelogin" className="btn mt-4">Login with Microsoft Account</button>
            <button id="azurelogout" className="btn mt-4">Logout with Microsoft Account</button> */}
        </>
    );
};



const AzureLogged = () => {    
    const { instance, accounts } = useMsal();


    // function azureLogin(){
    //     console.log( 'lgn', loginRequest)
    //     instance.loginRedirect(loginRequest).catch(e => {
    //         console.log('result', e);
    //     });
    // }
    
    useEffect( function() {
        var global = window.GlobalVars;
        console.log( 'ACCOUNTS LOG AZZURE', accounts, 'instance', instance )
        // return;
        if( !global.userEmail ) {
            console.log( 'LOGIN AZURE')
            window.post('login', { azure: accounts[0] }, function (res) {
                var data = res.data;
                console.log('LOGIN', data)
                // alert( JSON.stringify(data))
                if (data.status) {
                    window.endSession();
                    var global = window.GlobalVars;
                    global.user = data.email;
                    global.userName = data.name;
                    global.userSession = data.sid;
                    global.userId = data._id;
                    global.userEmail = data.email;
                    global.userWorkerId = data.workerId;
                    global.userRoles = data.roles;
                    global.userAzure = true;
                    if (data.roles.length == 1) {
                        global.userPriv = frm.arr2Bool((data.priv || data.roles[0].priv));
                        global.userCompany = data.company || data.roles[0].company;
                        global.userCurrentRole = data.currentRole;
                        global.usersupervisedProject = data.supervisedProject;
                    }
                    global.sessionId = Math.random();
                    global.expireTime = Date.now() + 1000 * 60 * window.sessionDuration;
                    if (data.redefinePassword) {
                        global.userRedefinePassword = data.redefinePassword;
                    }
                    window.saveSession();
                    console.log( 'GLOBAL', global )
                    window.pageHash = '';
                    // window.alertBox(' Signing in', 'loading')
                    setTimeout(function () {
                        window.goPage('')
                    }, 1000);
                }
                else {
                    frm.myAlert('Login Failed', data.value, 'Ok', function(){ document.location.reload() });
                }
            });
        }
    } );
    return (
        <>
        </>
    );
};



function Azure(prop) {
 
    var mode = 0;
    useEffect(function (a) {

    })
    return (
        <div className="azure">
            <UnauthenticatedTemplate>
                <AzureButton/>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                <AzureButton/>
                <AzureLogged />
            </AuthenticatedTemplate>
        </div>
    )
}

export default Azure
